import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Grid, Button, Box } from "@material-ui/core";
import { ReactComponent as CertificateIcon } from "../../../../web-app/src/assets/images/DownloadImg.svg";
import Download from "../../../../web-app/src/assets/images/Download.png";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { certificateListAction } from "examsbook-react-sdk/actions/certificateAddResponse";
import CommonButton from "../../constants/CommonButton";
import { useCertificateDownload, useTranslations } from "examsbook-react-sdk/custom-hooks";
import { useTheme } from "../../constants/themeProvider";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import { ReactComponent as CertificateVector } from "../../../../web-app/src/assets/images/vector-certificate.svg";
import { ColorsConstant } from "../../constants/colorConstant";
import status from "examsbook-react-sdk/constants/actionStatus.js";

const useStyles = makeStyles((theme) => ({
  subtitle: {
    color: ColorsConstant.subTitleTextColor,
    fontSize: "12px",
    width: "max-content",
    justifySelf: "center",
    fontWeight: 400,
    paddingBottom: 20,
    [theme.breakpoints.down("600")]: {
      width: "max-content",
      fontSize: "12px",
    },
  },
  btnText: {
    color: ColorsConstant.white,
    fontSize: "12px",
    fontWeight: 600,
    padding: "5px 20px",
    textTransform: "Capitalize",
    borderRadius: "6px",
    [theme.breakpoints.between("900", "1200")]: {
      fontSize: "1rem",
    },
    [theme.breakpoints.down("600")]: {
      fontSize: "14px",
      padding: "0px 15px",
    },
  },
  viewBtn: {
    borderRadius: "4px",
    padding: "0px",
    "&:hover": {
      backgroundColor: "#0c3450e0 !important",
    },
    "&:active": {
      boxShadow: "none",
    },
    "@media (max-width: 767px)": {
      marginLeft: 10,
    },
  },
  certificateData: {
    display: "flex",
    justifyContent: "space-around",
    [theme.breakpoints.between("900", "1100")]: {
      justifyContent: "end",
    },
  },
  content: {
    display: "flex",
    alignItems: "center",
    borderRadius: "7px",
    width: "100%",
    cursor: "pointer",
    justifyContent: "space-between",
    [theme.breakpoints.down("1536")]: {
      justifyContent: "center",
    },
    "&:hover": {
      transition: "0.3s all linear",
      backgroundColor: "transparent !important",
    },
  },
  certificateTitle: {
    margin: "0 10px",
    color: ColorsConstant.descriptionColor,
    textTransform: "capitalize",
    fontWeight: 400,
    fontSize: "14px",
    textAlign: "start",
    [theme.breakpoints.up("1600")]: {
      margin: "0 2rem 0 3rem",
    },
    [theme.breakpoints.between("900", "1200")]: {
      margin: "0px 0px 0px 10px",
      fontSize: "1em",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "80%",
    },
  },
  hrStyle: {
    margin: "10px 0",
    background: ColorsConstant.cardBorders,
    display: "block",
    width: "100%",
    height: 1,
  },
  downloadIcon: {
    width: "16px",
    height: "16px",
    display: "block",
    marginLeft: "auto",
    marginRight: "16px",
    [theme.breakpoints.between("900", "1200")]: {
      marginRight: "6px",
    },
  },
  dataRoot: {
    [theme.breakpoints.down("900")]: {
      display: "none",
    },
  },
  achievementCard: {
    padding: "8px",
    textAlign: "center",
    height: "100%",
    background: ColorsConstant.certificateBoxColor,
    borderRadius: "6px",
    border: "1px solid transparent",
    boxShadow: `${ColorsConstant.cardBoxShadow} !important`,
    "& svg": {
      width: 150,
      height: 150,
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
      border: 0,
      display: "flex",
      flexDirection: "row-reverse",
      justifyContent: "space-between",
      alignItems: "center",
      "& svg": {
        width: 100,
        height: 100,
        "& + div": {
          background: "none !important",
        },
      },
    },
  },
}));

function InnerCard(props) {
  const classes = useStyles();
  const user = useSelector((state) => state.user);
  const userName = user?.user?.name ? user?.user?.name : user?.name;
  const { handleDownloadCertificate } = useCertificateDownload({userName});

  return (
    <Button
      className={classes.content}
      onClick={() => handleDownloadCertificate(props?.name, props?.completedDate)}
      style={{ padding: 0 }}
    >
      <CertificateIcon className={classes.image} alt="Certificate" />
      <Typography variant="h6" className={classes.certificateTitle}>
        {props?.name}
      </Typography>
      <Box
        component="img"
        className={classes.downloadIcon}
        src={Download}
        alt="Download Icon"
      />
    </Button>
  );
}

InnerCard.propTypes = {
  name: PropTypes.string,
  completedDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function CertificateCard() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [certificateData, setCertificateData] = useState(null);
  const t = useTranslations();
  const theme = useTheme();
  const settings = useSelector((state) => state.settingsReducers);
  const isLoadingSettings = settings.status === status.PENDING;

  useEffect(() => {
    dispatch(certificateListAction()).then((res) => {
      setCertificateData(res?.data);
    });
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4} sm={12}>
        <Paper className={classes.achievementCard}>
          <CertificateVector />
          <Box
            style={{
              padding: "18px 18px",
              background: "#FFF",
              borderRadius: "6px",
            }}
          >
            <Box style={{ textAlign: "start" }}>
              <Typography
                style={{
                  fontSize: "14px",
                  fontWeight: 600,
                  color: `${theme?.primaryColor}`,
                }}
              >
                {t("Certificates")}
              </Typography>
              <Typography style={{ fontSize: "10px" }}>
                {t("Your achievements")}
              </Typography>
            </Box>
            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h6"
                style={{
                  fontSize: "34px",
                  color: `${theme?.secondaryColor}`,
                  fontWeight: "400",
                  paddingRight: "10px",
                }}
              >
                {certificateData === null ? "" : certificateData?.length || 0}
              </Typography>

              <CommonButton
                onClick={() => history.push("/certificate-list")}
                title={t("View All")}
                classStyleHeading={classes.viewBtn}
                classStyleText={classes.btnText}
              />
            </Box>
          </Box>
        </Paper>
      </Grid>

      {/* Second Box with xs={8} */}
      <Grid item xs={12} md={8} sm={12} className={classes.dataRoot}>
        <Paper
          className="commonShadow"
          style={{
            padding: 16,
            height: "100%",
            border: `1px solid ${ColorsConstant.lightGreyBorder}`,
          }}
        >
          <Typography
            style={{
              color: ColorsConstant.defaultBlue,
              fontSize: "18px",
              fontWeight: 500,
              paddingTop: "4px",
              marginBottom: 10,
            }}
          >
            {t("Recent Certificates")}
          </Typography>
          <List
            style={{
              padding: 0,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {certificateData?.length ? (
              certificateData
                ?.sort(
                  (a, b) => new Date(b?.completedOn) - new Date(a?.completedOn)
                )
                .slice(0, 4)
                .map((item) => {
                  const itemKey = item?._id || item?.courseId?._id || item?.completedOn || item?.courseId?.name;
                  return (
                    <React.Fragment key={itemKey}>
                      <Grid item xs={12}>
                        <InnerCard
                          name={item?.courseId?.name}
                          completedDate={item?.completedOn}
                        />
                      </Grid>
                      <span className={classes.hrStyle} />
                    </React.Fragment>
                  );
                })
            ) : (
              <>
                {!isLoadingSettings && !certificateData?.length && (
                  <div className={classes.subtitle}>
                    {t("No Certificate Found")}
                  </div>
                )}
              </>
            )}
          </List>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default CertificateCard;
